// Components
import { Button, Spinner } from "reactstrap"

// Third-party Library
import classnames from "classnames"

export const ActionButton = ({
	color = "primary",
	size = "md",
	className= "",
	block = false,
	children,
	disabled = false,
	loading,
	...rest
}) => (
	<Button {...rest} color={color} size={size} block={block} disabled={disabled || loading} className={className}>
		{loading && (
			<Spinner
				className={classnames({
					"position-relative": true,
					"button-style": !block,
					visible: loading,
					invisible: !loading
				})}
				size="sm"
			/>
		)}
		{!loading && (
			<span
				className={classnames({
					invisible: loading,
					visible: !loading,
					"span-style": !block
				})}
			>
				{children ?? "Submit"}
			</span>
		)}
	</Button>
)